const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  index ({ state, commit, rootState }, params = {}) {
    params = params.params ? params : { params }
    return rootState.axios.get('/jyo/v1frontend/jyorder-poll/index', params)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
